/** Estate Planning & Inheritance hub — registry. */
import { ESTATE_PLANNING_INHERITANCE_SLUG, estatePlanningInheritanceDefaultData } from "./estatePlanningInheritanceData";
import {
  EstatePlanningInheritanceArticlesTab,
  EstatePlanningInheritanceMediaTab,
  EstatePlanningInheritanceOverviewTab,
} from "./EstatePlanningInheritanceDesign";

export const estatePlanningInheritanceModule = {
  slug: ESTATE_PLANNING_INHERITANCE_SLUG,
  getDefaultData: () => estatePlanningInheritanceDefaultData,
  Views: {
    overview: EstatePlanningInheritanceOverviewTab,
    articles: EstatePlanningInheritanceArticlesTab,
    media: EstatePlanningInheritanceMediaTab,
  },
};
